import { sponsorAxiosInstance } from './base-service';
import { AxiosResponse } from 'axios';

export const CompNumberCheck = (compNumber: number): Promise<AxiosResponse<boolean>> => {
  return sponsorAxiosInstance.get<boolean>(`comp/v1/${compNumber}`);
};
